import { BaseSizeEnum as e } from "./common.js";
var r = /* @__PURE__ */ ((a) => (a.increase = "+", a.decrease = "-", a))(r || {});
const x = {
  [e.Large]: "52px",
  [e.Medium]: "44px",
  [e.Small]: "32px"
}, i = {
  [e.Large]: "32px",
  [e.Medium]: "24px",
  [e.Small]: "16px"
};
export {
  x as INPUT_HEIGHT,
  i as INPUT_NUMBER_CONTROL_SIZE,
  r as InputNumberCtrlButtonEnum
};
//# sourceMappingURL=input.js.map
